let containsModalsOpened = false;
import { hideElementsByClass, showElementsByClass } from './StyleChange'
import { closeAllPopupBus, setSelectMap } from "../MessageBus";

const getLastElementByClass = (className) => {
  const elements = document.getElementsByClassName(className);
  return elements.length ? elements[elements.length - 1] : null;
}

const getTopStateElement = () => {
  const candidates = [
    { state: 'full', element: getLastElementByClass('overlay') },
    { state: 'right', element: getLastElementByClass('modal-right') },
    { state: 'left', element: getLastElementByClass('modal-left') },
    { state: 'middle', element: getLastElementByClass('modal-dialog-middle') },
  ].filter((candidate) => candidate.element);

  if (!candidates.length) return null;

  return candidates.reduce((top, candidate) => {
    if (!top) return candidate;
    const isCandidateAfterTop = Boolean(
      top.element.compareDocumentPosition(candidate.element) & Node.DOCUMENT_POSITION_FOLLOWING
    );
    return isCandidateAfterTop ? candidate : top;
  }, null);
}

const closeResizeModal = () => {
  const overlay = document.getElementById('ResizeModal');
  overlay.style.display = "none"
  containsModalsOpened = false;
}

export const minimizeAll = () => {
  hideElementsByClass('overlay')

  const overlay = document.getElementById('ResizeModal');
  overlay.style.display = "block"

  containsModalsOpened = true;
}

export const modalToRight = () => {
  const from = stateModal();
  const overlay = getLastElementByClass('overlay');

  if (!overlay) return;

  const modal = overlay.children[0];
  const modaContainer = modal.children[0];

  overlay.classList.remove('overlay')

  modal.classList.replace('modal', `modal-right`)
  modaContainer.classList.replace(`modal-dialog-${from}`, 'modal-dialog-right');

  const modalFooter = modal.getElementsByClassName('modal-footer-diagram')[0];
  if (modalFooter) {
    modalFooter.classList.remove('full');
  }

}

export const modalToFull = () => {
  const from = stateModal();
  const elements = document.getElementsByClassName(`modal-${from}`)
  if (elements.length === 0) return;

  const overlay = document.getElementsByClassName(`modal-${from}`)[elements.length - 1].parentElement;

  if (!overlay) return;

  const modal = overlay.children[0];
  const modaContainer = modal.children[0];

  overlay.classList.add('overlay')

  modal.classList.replace(`modal-${from}`, 'modal')
  modaContainer.classList.replace(`modal-dialog-${from}`, 'modal-dialog-full');

  const modalFooter = modal.getElementsByClassName('modal-footer-diagram')[0];
  if (modalFooter) {
    modalFooter.classList.add('full');
  }
}


export const stateModal = (state) => {
  const topStateElement = getTopStateElement();
  if (topStateElement) return topStateElement.state;
}




export const showAll = () => {
  showElementsByClass('overlay')
  closeResizeModal()
  setSelectMap()

}

export const closeAll = () => {
  if (containsModalsOpened) {
    closeAllPopupBus()
    showAll()
  }
}
